export const CSTDateFormatterWithTime_12_hr = (dateVar,callingfrom) => {
    // const days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    // const months = ['Jan','Feb','March','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    if(dateVar === null || dateVar === undefined){
        return null;
    }
    const date = new Date(dateVar);
    // const day= days[date.getDay()];
    const month = date.getMonth() + 1;
    const dayOfMonth = String((date.getDate())).padStart(2, '0');
    const year = String(date.getFullYear());
    const hour_Upto_12 = String(date.getHours() % 12 || 12).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${month}-${dayOfMonth}-${year} ${hour_Upto_12}:${min} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
}

export const  DateFormatTo_YYYY_MM_DD = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return String([year,month, day].join('-'));
  }

  export const  DateFormatTo_MM_DD_YYYY = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return String([month, day, year].join('-'));
  }